export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const isEmailValid = (email: string) => {
  const trimmedEmail = email.trim()
  return EMAIL_REGEX.test(trimmedEmail)
}

export const isCommaSeperatedEmailsValid = (fieldData: string) => {
  let valid = true
  const toEmails = fieldData.split(',')
  toEmails.forEach((email) => {
    if (!isEmailValid(email)) {
      valid = false
    }
  })
  return valid
}
